module.exports = __webpack_public_path__ + "images/category_lp/alcohol/store_images/2_42871d32177b70126601623f6cabd069.png";